import { Link } from 'react-router-dom';


const StudyLink = (props) => {
  const client = localStorage.getItem('client')

  return (
    <Link to={`/${client}/studies/` + props.data?.uid}>{props.data?.org_study_id}</Link>
  );
};

export default StudyLink;
